import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import {
    ENV_SHAPE_PROP_TYPE,
    FOOTER_LINKS_SHAPE_PROP_TYPE,
    REQUEST_SHAPE_PROP_TYPE,
    SiteStructure,
    USER_SHAPE_PROP_TYPE,
} from '@eb/site-structure';
import { MarketingHeader } from '@eb/marketing-header';
import { getIndependentScrolling } from './utils';
import { scrollToTop } from '../components/utils';
import './page.scss';
import NotificationBar from 'eventbrite_design_system/notification/NotificationBar';
import { TYPE_WARNING } from 'eventbrite_design_system/notification/constants';
import gettext from '@eb/gettext';

const Covid19Notification = () => (
    <NotificationBar
        type={TYPE_WARNING}
        onCallAction={() => null}
        callAction={
            <a href="/l/coronavirus-resources-event-organizers/">
                {gettext('Learn more')}
            </a>
        }
    >
        {gettext(
            'Communities around the world are feeling the effects of the coronavirus (COVID-19) on their live experiences. We’re here to help in any way we can.',
        )}
    </NotificationBar>
);

class MarketingPage extends PureComponent {
    static propTypes = {
        env: ENV_SHAPE_PROP_TYPE.isRequired,
        request: REQUEST_SHAPE_PROP_TYPE.isRequired,
        user: USER_SHAPE_PROP_TYPE.isRequired,
        footerLinks: FOOTER_LINKS_SHAPE_PROP_TYPE.isRequired,
        children: PropTypes.node,
    };

    constructor(props) {
        super(props);
        const hasIndependentScrolling = getIndependentScrolling(props);

        this.state = {
            hasIndependentScrolling,
        };
    }

    componentWillReceiveProps(props) {
        const hasIndependentScrolling = getIndependentScrolling(props);

        scrollToTop();

        this.setState({
            hasIndependentScrolling,
        });
    }

    render() {
        const {
            env,
            request,
            user,
            footerLinks,
            children,
            router: { location: { pathname } } = {},
            featureFlags,
        } = this.props;
        const { hasIndependentScrolling } = this.state;

        const header = (
            <MarketingHeader
                env={env}
                request={request}
                user={user}
                requestPath={pathname}
                featureFlags={featureFlags}
            />
        );

        const covidNotification = <Covid19Notification />;

        return (
            <SiteStructure
                env={env}
                request={request}
                globalHeader={header}
                user={user}
                footerLinks={footerLinks}
                showMarketingLinks={true}
                fullScreenMain={true}
                hasIndependentScrolling={hasIndependentScrolling}
            >
                {covidNotification}
                {children}
            </SiteStructure>
        );
    }
}

export default withRouter(MarketingPage);
